/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {closeMessage} from '../../../common/components/messages/actions';

class ErrorMessage extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        closeMessage: React.PropTypes.func,
        title: React.PropTypes.string,
        content: React.PropTypes.string
    };

    render() {
        const {title, content, closeMessage, msg} = this.props;

        return (
            <div id="messages-page" className="pageNotification">
                <h1 className="pageNotification-logo">{msg.global.appName}</h1>

                <div className="pageNotification-content">
                        {!!title &&
                            <h2 className="pageNotification-title">{title}</h2>
                        }

                        {!!content &&
                            <div className="pageNotification-row">
                                {content}
                            </div>
                        }
                        <div className="pageNotification-row">
                            <button className="btn btn-green" onClick={() => closeMessage()}>
                                {msg.global.ok}
                            </button>
                        </div>
                </div>

            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    title: state.messages.get('title'),
    content: state.messages.get('content'),
}), {closeMessage})(ErrorMessage);



// WEBPACK FOOTER //
// ./src/browser/components/messages/ErrorMessage.js